import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setCompanyInformation, setCompanyType } from "./formSlice";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchCompanyInformation = createAsyncThunk(
  "companyInformationScreen/fetchCompanyInformation",
  async (country) => {
    return fetch(
      `${baseUrl}/api/registration-form-page/1/${country.countryCode}/`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Accept-Language":
            country.language === "en" ? "en-UK" : country.language,
        },
      }
    ).then((res) => errorStatusProvider(res));
  }
);

export const getCompanyInformation =
  (countryCode, language) => async (dispatch) => {
    const result = await dispatch(
      fetchCompanyInformation({ countryCode, language })
    );
    const { data, responseStatus } = result.payload;
    dispatch(setShowServerErrorMessage(responseStatus));
    dispatch(setCompanyInformation(data.page_content));
    if (data.page_content?.company_type?.options) {
      dispatch(setCompanyType(data.page_content.company_type.options[0].value));
    }
    return data;
  };

export const verifyCompanyDuplicate = async (country) => {
  return fetch(
    `${baseUrl}/api/check-existing-account/${country.companyName}/`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Accept-Language":
          country.languageISO === "en" ? "en-UK" : country.languageISO,
      },
    }
  ).then((res) => errorStatusProvider(res));
};

export const companyInformationSlice = createSlice({
  name: "companyInformationScreen",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyInformation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCompanyInformation.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
      })
      .addCase(fetchCompanyInformation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default companyInformationSlice.reducer;
